import type * as React from 'react';
import classnames from 'classnames';

import MenuLinks from './MenuLinks';
import { DefaultLink } from './defaultMenuLinks';
import { Link } from './Header';

interface MenuProps {
  links?: Array<Link | DefaultLink>;
  submenuTop?: React.ReactNode;
  submenuBottom?: React.ReactNode;
  /**
   * Nodes to be rendered before the links column
   */
  beforeLinks?: React.ReactNode;
  /**
   * When the menu is collapsed, passing in "open" will
   * expand it and make it visible.
   */
  open?: boolean;
  /**
   * Test ID for automated testing
   */
  'data-testid'?: string;
}

const Menu = (props: MenuProps) => {
  const classes = classnames('hc-c-menu', {
    'hc-c-menu--open': props.open,
  });
  const baseTestId = props['data-testid'] ?? 'menu';

  return (
    <div
      aria-hidden={!props.open}
      aria-label='Header menu'
      className={classes}
      data-testid={baseTestId}
      hidden={!props.open}
      id='hc-c-menu'
      role='region'>
      {props.submenuTop && <div data-testid={`${baseTestId}-submenu-top`}>{props.submenuTop}</div>}
      {props.beforeLinks && <div data-testid={`${baseTestId}-before-links`}>{props.beforeLinks}</div>}
      {props.links && (
        <MenuLinks
          data-testid={`${baseTestId}-links`}
          links={props.links}
        />
      )}
      {props.submenuBottom && <div data-testid={`${baseTestId}-submenu-bottom`}>{props.submenuBottom}</div>}
    </div>
  );
};

export default Menu;
